








import { computed, defineComponent } from '@vue/composition-api';
import { useStore } from '@/store';
import { ActionTypes } from '@/store/actions';

export default defineComponent({
    name: 'FixedBar',
    setup () {
        const store = useStore();
        const amount = computed(() => store.getters.itemsAmount);

        function toggleView (): void {
            store.dispatch(ActionTypes.SetIsComparing, true);
        }

        return { amount, toggleView };
    }
});
